<!-- Orbi entry point (PCSA-13157). Design: initial-chat-input "Agent CTA" /
     "Input" — an Orbi-mark-prefixed "Ask a question" bar. Reuses the PCSA-13160
     message input so idle / typing / listening states stay in one component.
     Self-gated on the Orbi flag and hidden while the panel is open. On send it
     opens the panel and submits the message. -->
<div class="orbi-entry" *ngIf="(enabled$ | async) && (pageSettled$ | async) && (panelOpen$ | async) === false">
  <patient-ui-orbi-message-input
    leadingIconSrc="assets/images/orbi-ai-icon.svg"
    placeholder="Ask a Question"
    [singleLine]="true"
    [showHistory]="true"
    (send)="onAsk($event)"
    (history)="onHistory()"
    (activate)="onActivate()"
  ></patient-ui-orbi-message-input>
</div>
